import { combineReducers } from 'redux-immutable';

import app from './app';

const Ducks = combineReducers({
    app,
});

export default Ducks;
